import {
  Button,
  Flex,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  Text,
  useDisclosure,
  useToast,
} from '@chakra-ui/react'
import { organizationListContext } from 'brokertslib/src/context'
import type {
  DetailedUser,
  OrganizationUnitGridItem,
  OrganizationUnitPagedQuery,
} from 'BrokerTsLib/src/dtos'
import {
  useGetAll,
  useTransferUser,
} from 'BrokerTsLib/src/hooks/useOrganizationUnit'
import { useState } from 'react'

import { ArrowLeft } from '../../../icons'
import {
  OrganizationListCityColumn,
  OrganizationListDescriptionColumn,
  OrganizationListNameColumn,
  OrganizationListTypeColumn,
  OrganizationsList,
} from '../../organization/OrganizationList'
import { OrganizationListFilter } from '../../organization/OrganizationListFilter'

const pageSize = 15
export const UserTransferButton = ({
  userId,
  organizationUnitId,
}: DetailedUser) => {
  const toast = useToast()
  const { isOpen, onClose, onOpen } = useDisclosure()
  const [filter, setFilter] = useState<OrganizationUnitPagedQuery>({
    showInvalid: false,
    showRootOnly: false,
    pageIndex: 1,
    pageSize,
    showAllItems: true,
  })

  const { data, refetch, isLoading } = useGetAll(filter, { enabled: isOpen })
  const { mutateAsync: transferUser, isLoading: isTransferUserLoading } =
    useTransferUser()

  const possibleOrganizations =
    data?.data.items.filter((x) => x.id !== organizationUnitId) ?? []

  const handleTransfer = (organization: OrganizationUnitGridItem) => {
    const userIds = [userId]
    transferUser({ userIds, organizationUnitId: organization.id })
      .then(() => {
        toast({
          title: `Uživatel byl přesunut do organizace ${organization.name}.`,
          status: 'success',
        })
      })
      .catch(() => {
        toast({
          title: `Chyba při přesunu uživatele do organizace ${organization.name}.`,
          status: 'error',
        })
      })
    onClose()
  }

  return (
    <>
      <Button
        type="button"
        variant="outline"
        onClick={onOpen}
        isLoading={isTransferUserLoading}
      >
        <ArrowLeft color="secondary.500" />
        Přesunout
      </Button>
      <Modal size="6xl" isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />

        <ModalContent>
          <ModalHeader>
            <Text>Přesunout uživatele do jiné organizace</Text>
            <ModalCloseButton />
          </ModalHeader>

          <ModalBody sx={{ pt: 0, pb: 6, gap: 4 }}>
            <organizationListContext.Provider
              value={{
                loading: isLoading,
                totalCount: data?.data.totalCount ?? 0,
                currentPage: filter.pageIndex,
                pageSize,
                filter,
                setCurrentPage: () => { },
                setPageSize: () => { },
                updateFilter: setFilter,
                reload: () => refetch(),
              }}
            >
              <Flex flexDir={'column'} gap={4}>
                <OrganizationListFilter />
                <OrganizationsList
                  organizations={possibleOrganizations}
                  withPaginator={true}
                  sx={{ boxShadow: 'none' }}
                  columnsDefinition={[
                    OrganizationListNameColumn,
                    OrganizationListDescriptionColumn,
                    OrganizationListCityColumn,
                    OrganizationListTypeColumn,
                    {
                      key: 'actions',
                      name: '',
                      cellExpr: (item) => (
                        <Button
                          size={'sm'}
                          colorScheme={'primary'}
                          onClick={() => handleTransfer(item)}
                        >
                          <ArrowLeft boxSize={'14px'} />
                          Přesunout
                        </Button>
                      ),
                    },
                  ]}
                />
              </Flex>
            </organizationListContext.Provider>
          </ModalBody>
        </ModalContent>
      </Modal>
    </>
  )
}
